import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Intro from './pages/intro';
import Home from './pages/home';
import LevelMap from './pages/levelMap';
import MainMenu from './pages/mainMenu';
import LevelOneExplanation from './pages/levelOneExplanation';
import LevelOne from './pages/levelOne';
import bgMusic from './assets/audios/bgMusic.mp4';
import Preloader from './components/layout/preloader';
import clickSound from './assets/audios/buttonClick.mp4';
import LevelOneDebrief from './pages/levelOneDebrief';
import LevelTwoExplanation from './pages/levelTwoExplanation';
import LevelTwo from './pages/levelTwo';
import LevelTwoDebrief from './pages/levelTwoDebrief';
import LevelThree from './pages/levelThree';
import LevelFour  from './pages/levelFour';
import LevelThreeDebrief from './pages/levelThreeDebrief';
import LevelFourDebrief from './pages/levelFourDebrief';
import EndlessDecode  from './pages/EndlessDecode';
import EndlessCollect from './pages/EndlessCollect';

const music = new Audio(bgMusic);
music.loop   = true;
music.volume = 0.4;

const click = new Audio(clickSound);
click.volume = 0.6;

const Path = () => {
const [started, setStarted] = useState(false);
  const [isMusicMuted, setIsMusicMuted] = useState(false);

const handleDone = () => {
  localStorage.removeItem('completedLevels');
  localStorage.removeItem('endlessLevel_decode');
  localStorage.removeItem('endlessLevel_collect');
  
  music.play().catch(() => {});
  setStarted(true);
};

  useEffect(() => {
    const handleButtonClick = (e) => {
      if (e.target.closest('button')) {
        click.currentTime = 0;
        click.play().catch(() => {});
      }
    };
    window.addEventListener('click', handleButtonClick);
    return () => window.removeEventListener('click', handleButtonClick);
  }, []);

  useEffect(() => {
    music.muted = isMusicMuted;
  }, [isMusicMuted]);

  const handleToggleMusic = () => setIsMusicMuted(m => !m);
  const musicProps = { isMusicMuted, onToggleMusic: handleToggleMusic };

  if (!started) return <Preloader onDone={handleDone} />;

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Intro {...musicProps} />} />
        <Route path='/home' element={<Home {...musicProps} />} />
        <Route path='/levelMap' element={<LevelMap {...musicProps} />} />
        <Route path='/mainMenu' element={<MainMenu {...musicProps} />} />
        <Route path='/levelOneExplanation' element={<LevelOneExplanation {...musicProps} />} />
        <Route path='/levelOne' element={<LevelOne {...musicProps} />} />
        <Route path='/levelOneDebrief' element={<LevelOneDebrief {...musicProps} /> } />
        <Route path='/levelTwoExplanation' element={<LevelTwoExplanation {...musicProps} /> } />
        <Route path='/levelTwo' element={<LevelTwo {...musicProps} />} />
        <Route path='/levelTwoDebrief' element={<LevelTwoDebrief {...musicProps} /> } />
        <Route path='/levelThree' element={<LevelThree {...musicProps} />} />
        <Route path='/levelThreeDebrief' element={<LevelThreeDebrief {...musicProps} /> } />
        <Route path='/levelFour'  element={<LevelFour  {...musicProps} />} />
        <Route path='/levelFourDebrief' element={<LevelFourDebrief {...musicProps} /> } />
        <Route path='/endless/decode'  element={<EndlessDecode  {...musicProps} />} />
        <Route path='/endless/collect' element={<EndlessCollect {...musicProps} />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Path;